import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';
import { Store } from '@ngrx/store';
import { catchError, from, map, of, switchMap } from 'rxjs';
import { DealerFeature } from '..';
import { DealerApiService } from '../../api/dealer-api.service';
import { actions } from '../contact';

@Injectable()
export class ContactEffects {
    actions$ = inject(Actions);
    api = inject(DealerApiService);
    store = inject(Store);

    submitContactForm1$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(actions.submitContactForm),
            concatLatestFrom(() => this.store.select(DealerFeature.state.selectDealerSlug)),
            switchMap(([action, slug]) => {
                return from(this.api.postContactForm(slug, action.payload)).pipe(
                    map(() => {
                        return actions.submitContactFormResponse({ success: true });
                    }),
                    catchError(() => {
                        return of(actions.submitContactFormResponse({ success: false }));
                    }),
                );
            }),
        );
    });

    submitContactFormLoading$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(actions.submitContactForm),
            concatLatestFrom(() => this.store.select(DealerFeature.state.selectDealerSlug)),
            map(() => {
                return actions.submitContactFormLoading({ loading: true });
            }),
        );
    });
}
